/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { NodeDependencies } from './dependenciesNode.generated.js';
import { createRangeNode } from '../../factoriesNumber.js';
export var RangeNodeDependencies = {
  NodeDependencies,
  createRangeNode
};